export const NEXT_PAGE = 'NEXT_PAGE';
export const NEXT_SEGMENT = 'NEXT_SEGMENT';

export const nextPage = () => ({
  type: NEXT_PAGE,
});

export const nextSegment = (values) => ({
  type: NEXT_SEGMENT,
  payload: values,
});
